import { useEffect } from 'react'

import { useSnackbar, type VariantType } from 'notistack'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState } from 'reducers'

import { removeNotification } from 'actions/notification-actions'

// Bridge the redux notification queue into notistack, which stacks toasts and auto-hides each one on
// its own timer, then drain redux (notistack owns display + dismissal from there).
const CoreLayoutNotifications = () => {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useDispatch()
  const notifications = useSelector((s: RootState) => s.notifications)

  useEffect(() => {
    notifications.forEach(notification => {
      enqueueSnackbar(notification.message, { key: notification.id, variant: notification.type as VariantType })
      dispatch(removeNotification(notification.id))
    })
  }, [notifications, enqueueSnackbar, dispatch])

  return null
}

export default CoreLayoutNotifications
